import React, { useState, useEffect } from "react";
import { orderBy } from "@progress/kendo-data-query";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import { GridLoader } from "components/GridLoader";
import { ActiveCell, EditCommandCell, SignatureCell } from "../GridComponents";
import { Button } from "@progress/kendo-react-buttons";
import ContactLinkTypeModal from "./ContactLinkTypeModal";
import { getContactLinks } from "api/index";

const initialSort = [
  {
    field: "categoryName",
    dir: "asc",
  },
];

const ContactLinkDataGrid = () => {
  const [data, setData] = useState([]);
  const [sort, setSort] = useState(initialSort);
  const [modalData, setModalData] = useState(null);
  const [modal, setModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getItems = async () => {
    setIsLoading(true);
    try {
      const { data } = await getContactLinks();
      setData(data.data ?? []);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getItems();
  }, []);

  const enterEdit = (dataItem) => {
    return handleModalOpen(dataItem);
  };

  const CommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  const BlankHeader = () => <span />;

  const handleModalOpen = (actionData = null) => {
    setModalData(actionData);
    setModal(true);
  };

  const handleModalClose = (shouldRefresh = false) => {
    if (shouldRefresh) {
      getItems();
    }
    setModal(false);
  };

  return (
    <div className="d-flex flex-column h-100 w-100">
      <div className="d-flex justify-content-end mb-3 flex-shrink-0">
        <Button
          className={`common-btn p-3 py-4`}
          onClick={() => {
            handleModalOpen(null);
          }}
        >
          Add Contact<br />
          Category
        </Button>
      </div>
      <div className="flex-grow-1 settings-grid-wrapper mt-2" style={{ minHeight: 0 }}>
        <div className="settings-grid h-100">
          <Grid
            style={{ height: "100%", width: "max-content", maxWidth: "100%" }}
            resizable={true}
            reorderable={true}
            data={orderBy(data, sort)}
            sortable={true}
            sort={sort}
            onSortChange={(e) => {
              setSort(e.sort);
            }}
            rowHeight={40}
            scrollable="scrollable"
            dataItemKey={"contactCategoryId"}
            showLoader={isLoading}
            loader={
              <div style={{ height: "50px" }}>
                <GridLoader />
              </div>
            }
          >
            <GridNoRecords>
              {isLoading ? (
                <span></span>
              ) : (
                data.length === 0 && "No records available"
              )}
            </GridNoRecords>
            <Column
              field="categoryName"
              title=" "
              cell={SignatureCell}
              width="80"
              sortable={false}
              headerCell={BlankHeader}
            />
            <Column field="categoryName" title="Name" width={"120"} />
            <Column field="categoryDetails" title="Details" width={"180"} />
            <Column field="labelForRef1" title="Reference 1" width={"120"} />
            <Column field="labelForRef2" title="Reference 2" width={"120"} />
            <Column field="labelForRef3" title="Reference 3" width={"120"} />
            <Column
              field="active"
              cell={ActiveCell}
              title="Active"
              editor="boolean"
              width="80"
            />
            <Column cell={CommandCell} width="80" />
          </Grid>
        </div>
      </div>
      {modal && (
        <ContactLinkTypeModal onClose={handleModalClose} data={modalData} />
      )}
    </div>
  );
};
export default ContactLinkDataGrid;
